const publicImage = (filename) => `/${encodeURIComponent(filename)}`;

export const images = {
  branding: {
    logo: publicImage("Transparent Logo.png"),
  },
  home: {
    banner: publicImage("Ignite Events.webp"),
  },
  team: {
    alison: publicImage("Alison-Headshot.webp"),
    willie: publicImage("Willie-Ignite headshot.webp"),
  },
  events: {
    conferences: publicImage("Conferences.jpg"),
    teamDays: publicImage("Team Days_Comms Days.jpg"),
    galaDinners: publicImage("Gala Dinners.jpg"),
    tradeShows: publicImage("Trade Shows.jpg"),
  },
};

export const ALL_IMAGES = [
  images.branding.logo,
  images.home.banner,
  images.team.alison,
  images.team.willie,
  ...Object.values(images.events),
];
